// extracted by mini-css-extract-plugin
export var chevron = "_ka-2";
export var dropdownItems = "_ka-0";
export var item = "_ka-1";